import {
  generateAIText,
  getAITextHistory,
  adaptAiText,
} from '../../api/helpers';

const createFieldLabel = (title) => {
  return $(`<span>${title}</span>`).css({
    color: '#ffffff',
    fontSize: '12px',
    lineHeight: '16px',
    fontFamily: 'Open Sans',
  });
};

const createAITextDropdown = async () => {
  const createDropdown = (dropdownId) => {
    const dataArray = [
      { value: 'headline', label: 'Headline' },
      { value: 'body', label: 'Body' },
      { value: 'free-form', label: 'Free-form' },
    ];

    const dropdown = $('<select></select>').attr('id', dropdownId).css({
      width: '100%',
      height: '45px',
      borderRadius: '8px',
      marginBottom: '30px',
      fontSize: '14px',
      paddingLeft: '15px',
      paddingRight: '15px',
      backgroundColor: '#ffffff',
      cursor: 'pointer',
      outline: 'none',
    });

    $.each(dataArray, (index, item) => {
      dropdown.append(
        $('<option></option>')
          .attr('value', item.value)
          .text(item.label)
          .css('cursor', 'pointer'),
      );
    });

    return dropdown;
  };
  const writingForDropdown = createDropdown('writing-for');

  const optionalFieldLabel = $('<p>Optional</p>').css({
    margin: '0',
    color: 'rgba(255, 255, 255, 0.60)',
    fontFamily: 'Open Sans',
    fontSize: '12px',
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '16px',
    marginBottom: '4px',
  });

  return $('<div id="test-test"></div>')
    .append(optionalFieldLabel)
    .append(createFieldLabel('What are you writing for?'), writingForDropdown);
};

const renderAIText = async (cesdk, userCredits) => {
  const rootShadowElement = $('#root-shadow')[0];

  const typeface = {
    name: 'Roboto',
    fonts: [
      {
        uri: 'https://cdn.img.ly/assets/v2/ly.img.typeface/fonts/Roboto/Roboto-Bold.ttf',
        subFamily: 'Bold',
        weight: 'bold',
      },
      {
        uri: 'https://cdn.img.ly/assets/v2/ly.img.typeface/fonts/Roboto/Roboto-BoldItalic.ttf',
        subFamily: 'Bold Italic',
        weight: 'bold',
        style: 'italic',
      },
      {
        uri: 'https://cdn.img.ly/assets/v2/ly.img.typeface/fonts/Roboto/Roboto-Italic.ttf',
        subFamily: 'Italic',
        style: 'italic',
      },
      {
        uri: 'https://cdn.img.ly/assets/v2/ly.img.typeface/fonts/Roboto/Roboto-Regular.ttf',
        subFamily: 'Regular',
      },
    ],
  };

  if (!rootShadowElement) {
    return;
  }
  const shadowRootEl = rootShadowElement.shadowRoot;

  const textAreaBox = $('<textarea></textarea>')
    .attr({
      id: 'user-prompt',
      placeholder: 'What do you want to write about?',
      maxlength: 250,
    })
    .css({
      width: 'calc(100% - 22px)',
      height: '85px',
      borderRadius: '8px',
      marginBottom: '20px',
      padding: '10px',
      outline: 'none',
    });

  const generateContent = $('<div class="generate-content"></div>').css({
    display: 'block',
    padding: '12px',
  });
  const generateContentContainer = $('<div></div>')
    .css('height', '100%')
    .append(generateContent);

  const historyContent = $('<div class="history-content"></div>').css({
    height: '100%',
    overflowY: 'scroll',
    padding: '12px',
  });
  const historyContentContainer = $('<div></div>')
    .css('height', '100%')
    .append(historyContent);

  const checkIfAllFieldsFilled = () => {
    const selectedWritingFor = $('#writing-for', generateContent).val();
    const userPrompt = $('#user-prompt', generateContent).val();

    return selectedWritingFor && userPrompt;
  };

  const styles = {
    svg: `
      width: 18px;
      height: 18px;
      fill: none;
      margin-left: 12px;
      margin-top: 4px;
    `,
    path: `
      d: path('M5.04584 14C4.40724 14 3.86078 13.7787 3.40648 13.3362C2.95217 12.8937 2.71112 12.3557 2.68333 11.7221C1.96278 11.6057 1.3632 11.2731 0.884585 10.7242C0.405968 10.1753 0.16666 9.53237 0.16666 8.79549C0.16666 8.53581 0.199441 8.27794 0.265005 8.02189C0.330554 7.76584 0.434445 7.52541 0.57668 7.30059C0.384453 7.05627 0.240283 6.7845 0.14417 6.48529C0.0480565 6.18607 0 5.87038 0 5.53823C0 4.77475 0.259169 4.11515 0.777508 3.55944C1.29583 3.00374 1.935 2.68251 2.69501 2.59577C2.6839 2.55734 2.67835 2.51479 2.67835 2.46811V2.31577C2.68112 1.67012 2.91264 1.12275 3.37291 0.673656C3.8332 0.224552 4.39084 0 5.04584 0C5.47306 0 5.83402 0.0842838 6.1287 0.252851C6.42338 0.421419 6.71243 0.665997 6.99584 0.986588C7.2964 0.665412 7.58696 0.42069 7.86751 0.252423C8.14807 0.0841407 8.50751 0 8.94584 0C9.59065 0 10.1421 0.226886 10.6003 0.680657C11.0584 1.13441 11.2917 1.68137 11.3 2.32152C11.3 2.37644 11.2986 2.42585 11.2958 2.46976C11.2931 2.51368 11.2889 2.5576 11.2833 2.60153C12.0378 2.68278 12.6792 2.99977 13.2075 3.55251C13.7358 4.10523 14 4.76714 14 5.53823C14 5.87038 13.9478 6.18607 13.8434 6.48529C13.7389 6.7845 13.5933 7.05805 13.4067 7.30594C13.5433 7.52637 13.6486 7.76415 13.7225 8.0193C13.7964 8.27444 13.8333 8.53269 13.8333 8.79406C13.8333 9.54374 13.5922 10.1932 13.11 10.7425C12.6278 11.2918 12.0228 11.6184 11.295 11.7221C11.2617 12.3557 11.0214 12.8937 10.5743 13.3362C10.1271 13.7787 9.58433 14 8.94584 14C8.50528 14 8.14529 13.9181 7.86584 13.7542C7.5864 13.5903 7.2964 13.3395 6.99584 13.0019C6.69196 13.3324 6.39973 13.5814 6.11916 13.7488C5.83861 13.9163 5.48083 14 5.04584 14ZM7.40001 2.32647V11.6818C7.40001 12.1054 7.55116 12.466 7.85345 12.7633C8.15574 13.0607 8.52226 13.2094 8.95299 13.2094C9.36822 13.2094 9.72306 13.0695 10.0175 12.7898C10.3119 12.5101 10.4728 12.1514 10.5 11.7139C10.0723 11.682 9.67557 11.5629 9.30988 11.3565C8.94419 11.15 8.63729 10.8728 8.38918 10.5247C8.32028 10.438 8.2947 10.3416 8.31244 10.2355C8.33017 10.1294 8.38659 10.046 8.48168 9.98528C8.56945 9.9172 8.66912 9.89193 8.78068 9.90946C8.89221 9.92699 8.98005 9.97999 9.04418 10.0685C9.24532 10.3623 9.50422 10.586 9.82087 10.7393C10.1375 10.8927 10.4736 10.9694 10.8292 10.9694C11.4485 10.9694 11.9707 10.7608 12.3958 10.3435C12.8208 9.92614 13.0333 9.41146 13.0333 8.79941C13.0333 8.64605 13.014 8.49269 12.9754 8.33934C12.9368 8.18597 12.8864 8.03627 12.8242 7.89023C12.5786 8.08403 12.2983 8.23391 11.9833 8.33987C11.6683 8.44585 11.3392 8.49883 10.9958 8.49883C10.8836 8.49883 10.7896 8.4613 10.7138 8.38625C10.6379 8.31119 10.6 8.21813 10.6 8.10706C10.6 7.99599 10.6379 7.90175 10.7138 7.82434C10.7896 7.74693 10.8836 7.70822 10.9958 7.70822C11.6152 7.70822 12.1374 7.49957 12.5624 7.08227C12.9875 6.66496 13.2 6.15028 13.2 5.53823C13.2 4.95086 12.9885 4.44771 12.5654 4.02877C12.1424 3.60983 11.6361 3.38691 11.0467 3.36002C10.9056 3.62793 10.7208 3.86236 10.4921 4.06331C10.2635 4.26425 10.0041 4.41907 9.71418 4.52777C9.61417 4.56785 9.51546 4.56575 9.41804 4.52145C9.32062 4.47717 9.25682 4.40379 9.22666 4.3013C9.18778 4.20247 9.18848 4.10297 9.22876 4.00277C9.26903 3.90257 9.34472 3.83325 9.45583 3.79482C9.77029 3.68886 10.0229 3.50206 10.2138 3.23441C10.4046 2.96677 10.5 2.66016 10.5 2.31459C10.5 1.89867 10.3481 1.5407 10.0444 1.24066C9.74068 0.940625 9.37443 0.790607 8.94567 0.790607C8.5169 0.790607 8.1521 0.94066 7.85126 1.24077C7.55043 1.54089 7.40001 1.90279 7.40001 2.32647ZM6.60001 11.6818V2.32647C6.60001 1.90279 6.44814 1.54089 6.14441 1.24077C5.84068 0.94066 5.47444 0.790607 5.04567 0.790607C4.6169 0.790607 4.2521 0.940974 3.95126 1.24171C3.65043 1.54246 3.50001 1.90513 3.50001 2.32973C3.50001 2.66356 3.59321 2.96471 3.7796 3.23317C3.96599 3.50165 4.2164 3.68886 4.53085 3.79482C4.63084 3.83325 4.70737 3.90197 4.76043 4.00098C4.81348 4.09998 4.82429 4.19579 4.79286 4.28841C4.74894 4.38867 4.67623 4.46091 4.57474 4.50512C4.47326 4.54931 4.36695 4.55137 4.25583 4.5113C3.96587 4.40259 3.70656 4.25051 3.47789 4.05506C3.24922 3.85962 3.06715 3.62793 2.93167 3.36002C2.3439 3.3924 1.84168 3.61653 1.42502 4.03241C1.00834 4.4483 0.799998 4.95201 0.799998 5.54356C0.799998 6.15206 1.01114 6.66496 1.43342 7.08227C1.85569 7.49957 2.3765 7.70822 2.99585 7.70822C3.10807 7.70822 3.20348 7.74712 3.28209 7.82492C3.36069 7.90272 3.4 7.99715 3.4 8.10822C3.4 8.21929 3.36069 8.31216 3.28209 8.38683C3.20348 8.4615 3.10807 8.49883 2.99585 8.49883C2.65382 8.49883 2.32678 8.44626 2.01474 8.34111C1.7027 8.23598 1.4239 8.08651 1.17834 7.89271C1.11057 8.04423 1.05834 8.19548 1.02167 8.34647C0.98501 8.49745 0.96668 8.64843 0.96668 8.79941C0.96668 9.41146 1.17781 9.92614 1.60008 10.3435C2.02235 10.7608 2.54316 10.9694 3.16251 10.9694C3.52135 10.9694 3.85735 10.8918 4.17051 10.7366C4.48366 10.5814 4.74266 10.3587 4.9475 10.0685C5.01163 9.97999 5.09946 9.92699 5.211 9.90946C5.32256 9.89193 5.42501 9.91446 5.51835 9.97706C5.60613 10.0396 5.65932 10.1249 5.67792 10.2328C5.69654 10.3406 5.6714 10.438 5.6025 10.5247C5.34331 10.8703 5.03002 11.1463 4.66262 11.3525C4.29524 11.5588 3.90048 11.6801 3.47834 11.7164C3.50001 12.1484 3.66126 12.5053 3.9621 12.7869C4.26293 13.0686 4.6218 13.2094 5.03869 13.2094C5.46942 13.2094 5.83732 13.0607 6.14239 12.7633C6.44747 12.466 6.60001 12.1054 6.60001 11.6818Z');
      stroke: currentcolor;
      stroke-opacity: 0.9;
      stroke-width: 1.5;
      stroke-linecap: square;
    `,
    btn: `
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80%;
      height: 44px;
      border-radius: 8px;
      background-color: rgb(33, 33, 33);
      color: rgb(255, 255, 255);
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      tracking: 2.56px;
      margin-left: auto;
      border: none;
    `,
  };

  const generateBtnIcon = `
    <svg
      style="${styles.svg}"
    >
      <path style="${styles.path}"></path>
    </svg>
`;
  const generateBtn = $(`
      <button
        type="button"
        id="generate-btn"
        style="${styles.btn}"
      >
        <div>GENERATE</div>
      </button>
    `)
    .css({
      width: '100%',
      maxWidth: '240px',
      height: '44px',
      borderRadius: '8px',
      backgroundColor: '#252525',
      color: '#ffffff',
      fontSize: '18px',
      fontWeight: '600',
      lineHeight: '2.5rem',
      marginLeft: 'auto',
    })
    .append(generateBtnIcon);

  const applyTextToCesdk = async (text, fontSize = 16) => {
    const selectedValue = cesdk.engine.block.findAllSelected()[0];
    const isTextElementSelected =
      selectedValue &&
      cesdk.engine.block.getType(selectedValue) === '//ly.img.ubq/text';
    const selectedElements = cesdk.engine.block.findAllSelected();

    if (isTextElementSelected) {
      cesdk.engine.block.replaceText(selectedValue, text);
    } else {
      const customTextEl = cesdk.engine.block.create('text');
      const pageEl = cesdk.engine.block.findByType('page')[0];

      cesdk.engine.block.setString(customTextEl, 'text/text', text);
      cesdk.engine.block.setFloat(customTextEl, 'height', 500);
      cesdk.engine.block.setFloat(customTextEl, 'width', 500);
      cesdk.engine.block.setFloat(customTextEl, 'text/fontSize', fontSize);
      cesdk.engine.block.setFont(customTextEl, typeface.fonts[3].uri, typeface);

      if (selectedElements) {
        selectedElements.forEach((selectedEl) => {
          cesdk.engine.block.setSelected(selectedEl, false);
        });
      }

      cesdk.engine.block.appendChild(pageEl, customTextEl);
      cesdk.engine.block.setSelected(customTextEl, true);

      const savedScene = await cesdk.save();

      const data = new FormData();
      data.append('scene_bytes', savedScene);
      data.append('text_id', customTextEl);

      const updatedScene = await adaptAiText(data);
      cesdk.load(updatedScene.updated_scene);
    }
  };

  const resetInputFields = () => {
    $('.svg-btn', shadowRootEl).each((_, el) => {
      $(el)
        .parent()
        .removeClass('tone-selected')
        .css('background-color', 'transparent');
    });

    $('#user-prompt', shadowRootEl).val('');

    $('#generate-btn', shadowRootEl)
      .css({
        cursor: 'not-allowed',
        opacity: 0.7,
      })
      .prop('disabled', true);
  };

  let innerUserCredits = $('#userCredits', shadowRootEl).text();

  const userCreditsObserver = new MutationObserver(() => {
    $('#userCreditsLabel', shadowRootEl).text(
      `${$('#userCredits', shadowRootEl).text()} credits`,
    );
  });

  userCreditsObserver.observe($('#userCredits', shadowRootEl)[0], {
    childList: true,
  });

  const userCreditsLabel = $(`<p>${innerUserCredits} credits</p>`)
    .css({
      color: 'rgba(255, 255, 255, 0.4)',
      textAlign: 'right',
      fontFamily: 'Open Sans',
      fontSize: '12px',
      fontStyle: 'italic',
      fontWeight: 300,
      lineHeight: '16px',
      textTransform: 'lowercase',
    })
    .attr('id', 'userCreditsLabel');

  const handleGenerateBtnClick = async () => {
    const writingFor = $('#writing-for', generateContent).val();
    const userPrompt = $('#user-prompt', generateContent).val();
    const brandRoom = $('#brand-room', generateContent).prop('checked');
    const isAllFieldsFilled = checkIfAllFieldsFilled();

    generateBtn
      .text('Loading...')
      .prop('disabled', true)
      .css({
        cursor: `${!isAllFieldsFilled ? 'not-allowed' : 'pointer'}`,
        opacity: `${!isAllFieldsFilled ? 0.7 : 1}`,
      });

    try {
      const response = await generateAIText({
        writing_for: writingFor,
        user_prompt: userPrompt,
        brand_room: brandRoom,
      });

      applyTextToCesdk(response.completion);
      resetInputFields();

      innerUserCredits = response.userCredits;
      userCreditsLabel.text(`${innerUserCredits} credits`);
    } catch (error) {
      console.error('Error occurred during the request:', error);
    } finally {
      setTimeout(() => {
        const innerIsAllFieldsFilled = checkIfAllFieldsFilled();
        generateBtn
          .text('GENERATE')
          .append(generateBtnIcon)
          .prop('disabled', true)
          .css({
            cursor: `${!innerIsAllFieldsFilled ? 'not-allowed' : 'pointer'}`,
            opacity: `${!innerIsAllFieldsFilled ? 0.7 : 1}`,
          });
      }, 1000);
    }
  };

  generateBtn.click(handleGenerateBtnClick);

  const onFieldChange = () => {
    const allFieldsFilled = checkIfAllFieldsFilled();
    generateBtn
      .css({
        cursor: `${!allFieldsFilled ? 'not-allowed' : 'pointer'}`,
        opacity: `${!allFieldsFilled ? 0.7 : 1}`,
      })
      .prop('disabled', !allFieldsFilled);
  };

  const dropdownGroup = await createAITextDropdown();
  const sidebarEl = $("[class^='UBQ_AssetLibraryContent']", shadowRootEl);

  const aiTextContainerId = 'ai-text-container';
  const customAITextContainer = $('<div></div>')
    .attr('id', aiTextContainerId)
    .css('height', '95%');

  const btn = (text, isSelected = false) => {
    return $('<button></button>')
      .text(text)
      .css({
        background: '#545454',
        color: `${isSelected ? '#ffffff' : '#787878'}`,
        padding: '10px',
        cursor: 'pointer',
        border: 0,
        fontSize: '16px',
        fontWeight: 700,
      });
  };
  const generateTabBtn = btn('GENERATE', true);
  const historyTabBtn = btn('HISTORY');

  const tabContainer = $('<div class="tab-container"></div>')
    .css({
      display: 'flex',
      justifyContent: 'space-between',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      padding: '10px',
      zIndex: '10000',
      background: '#545454',
    })
    .attr('id', 'tab-container')
    .append(generateTabBtn, historyTabBtn);

  const sidebarContentContainer = $(
    '[class*=UBQ_AssetLibraryOverview-module__block]',
    sidebarEl,
  );

  if (
    !$('#tab-container', shadowRootEl).length &&
    $('#ai-text-container', shadowRootEl).length &&
    $($('h2[data-cy*="panel-title"]', shadowRootEl)[0]).text() ===
      'Write your text with A.I.'
  ) {
    $('[class*=UBQ_AssetLibraryEmpty-module__block', sidebarEl).hide();
    sidebarContentContainer.css('overflow-y', 'hidden');
    sidebarContentContainer.append(tabContainer);
  }

  const showGenerateContent = () => {
    resetInputFields();
    $('.generate-content', shadowRootEl).parent().show();
    $('.history-content', shadowRootEl).parent().hide();
    $('.history-content', shadowRootEl).empty();
    generateTabBtn.css({ color: '#ffffff' });
    historyTabBtn.css({ color: '#787878' });
  };
  const showHistoryContent = () => {
    resetInputFields();
    $('.generate-content', shadowRootEl).parent().hide();
    $('.history-content', shadowRootEl).parent().show();
    generateTabBtn.css({ color: '#787878' });
    historyTabBtn.css({ color: '#ffffff' });
  };

  generateTabBtn.click(() => {
    showGenerateContent();
  });

  historyTabBtn.click(async () => {
    showHistoryContent();
    const AITextHistoryData = await getAITextHistory(prompt);
    AITextHistoryData.forEach((item) => {
      const aiTextElement = $('<p></p>')
        .text(item.completion)
        .css({
          backgroundColor: '#484848',
          padding: '16px',
          color: '#EEEEEEE5',
          fontSize: '14px',
          borderRadius: '8px',
          cursor: 'pointer',
        })
        .on('click', (el) => {
          applyTextToCesdk(el.target.innerText);
        });
      $('.history-content', shadowRootEl).append(aiTextElement);
    });

    $('.history-content', shadowRootEl)
      .parent()
      .append($('.history-content', shadowRootEl));
  });

  if (
    $($('h2[data-cy*="panel-title"]', shadowRootEl)[0]).text() ===
    'Write your text with A.I.'
  ) {
    sidebarContentContainer.css('overflow-y', 'hidden');
    customAITextContainer.append(
      generateContentContainer,
      historyContentContainer,
    );
  }

  const brandRoomCheckbox = $('<div></div>')
    .css({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '30px',
    })
    .append(
      createFieldLabel('Brand Room'),
      $('<input />')
        .css({
          width: '20px',
          height: '20px',
          cursor: 'not-allowed',
        })
        .attr({
          type: 'checkbox',
          id: 'brand-room',
          disabled: true,
        }),
    );

  $('[class*=UBQ_MasonryGrid-module__block]', sidebarEl).parent().empty();
  if (!$(`#${aiTextContainerId}`, sidebarEl).length) {
    generateContent.append(createFieldLabel('Prompt'));
    generateContent.append(textAreaBox);
    generateContent.append(brandRoomCheckbox);
    generateContent.append(dropdownGroup);
    generateContent.append(generateBtn);
    generateContent.append(userCreditsLabel);
  }
  if (
    $($('h2[data-cy*="panel-title"]', shadowRootEl)[0]).text() ===
      'Write your text with A.I.' &&
    !$('#ai-text-container', shadowRootEl).length
  ) {
    sidebarContentContainer.css('overflow-y', 'hidden');
    sidebarContentContainer.append(customAITextContainer);
  }

  $('#writing-for', generateContent).on('change', onFieldChange);
  $('.svg-btn', generateContent).on('click', onFieldChange);
  $('#user-prompt', generateContent).on('input', onFieldChange);

  generateBtn
    .css({
      cursor: 'not-allowed',
      opacity: 0.7,
    })
    .prop('disabled', true);
};

export default renderAIText;
